import Pages from '../pages/Pages';
import { signOutEverywhere } from '../auth/logout';
import { signIn } from '../auth/firebaseAuth';

// The logo lives in ui/public, which webpack copies to the web root, so it is
// referenced by its root URL path (the same convention as misc/ReactiveImage).
const LOGO_URL = '/UIDheaderlogo.webp';

// Base Utah Design System header settings.
// See https://designsystem.utah.gov/library/utahHeader for the settings shape.
// The dynamic mainMenu and current-user are composed by UtahHeader from the
// live menu/auth state and merged into these settings before
// setUtahHeaderSettings() is called.
export default () => ({
  logo: { imageUrl: LOGO_URL },
  // The app renders its own footer (<Footer />, modeled on the main Utah
  // Insurance Department site footer), so suppress the Utah Design System
  // header's default footer to avoid a duplicate.
  footer: null,
  title: '',
  showTitle: false,
  titleUrl: '/',
  titleFunction: (event) => {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
    Pages.home.forward();
  },
  size: 'MEDIUM',
  applicationType: 'custom application',
  utahId: {
    // The app controls authentication (Firebase + id.utah.gov OIDC); the header
    // only reflects/triggers it.
    onSignIn: (event) => {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      // Start the id.utah.gov OIDC sign-in (signInWithRedirect) so the button
      // navigates the browser to the IdP login page. Fall back to the
      // landing/sign-in screen if the redirect cannot be started.
      Promise.resolve(signIn()).catch(() => Pages.home.forward());
    },
    onSignOut: (event) => {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      // End BOTH the Firebase Auth session AND the id.utah.gov OIDC SSO session
      // — identical to the main-menu "Sign Out". The event is forwarded so
      // signOutEverywhere also blocks the control's default action (page
      // refresh) before it deletes local data/cookies and redirects to the Utah
      // ID (Ping) logout; Firebase is invalidated on the return. Returned so
      // callers/tests can await the async logout.
      return signOutEverywhere(event);
    },
    onProfile: () => {
      window.location.href = 'https://id.utah.gov';
    },
  },
});
